angular.module('admin.directives')

  .directive('agentImportClientsAction', ['AgentService', 'PageNotificationService', function(AgentService, PageNotificationService){
    return {
      restrict: 'E',
      controllerAs: 'agentImportCtrl',
      bindToController: {
        agentId: '@',
      },
      scope: {},
      templateUrl: '/admin/templates/partials/agent-import-clients-action.html',

      controller: function(){
        var ctrl = this;

        ctrl.importClients = function(){
          if(!confirm('Import clients for this agent?'))
            return;

          ctrl.loading = true;

          return AgentService.importClients(ctrl.agentId)
            .then(success)
            .catch(error);
        };

        function success(){
          ctrl.loading = false;
          PageNotificationService.info('Successfully imported clients.');
        }

        function error(err){
          ctrl.loading = false;
          PageNotificationService.info('There was an error importing clients.');
        }
      }
    }

  }]);
